import $ from 'jquery';

export default ({ openButtonSelector, closeButtonSelector, modalSelector }, classes) => {
  const $$ = {
    openButton: $(openButtonSelector),
    closeButton: $(closeButtonSelector),
    modal: $(modalSelector),
    body: $('body'),
  };
  const uiClasses = {
    bodyActiveClass: '',
    modalActiveClass: '',
    ...classes,
  };

  const openModal = () => {
    $$.body.addClass(uiClasses.bodyActiveClass);
    $$.modal.addClass(uiClasses.modalActiveClass);
  };

  const closeModal = () => {
    $$.body.removeClass(uiClasses.bodyActiveClass);
    $$.modal.removeClass(uiClasses.modalActiveClass);
  };

  const keyupListener = (e) => {
    if (e.key !== 'Escape') {
      return;
    }

    closeModal();
  };

  const eventHandlers = {
    openButtonOnClick: () => {
      openModal();
      $(document).on('keyup.modal', keyupListener);
    },
    closeButtonOnClick: () => {
      closeModal();
      $(document).off('.modal');
    },
  };

  $$.openButton.on('click', eventHandlers.openButtonOnClick);
  $$.closeButton.on('click', eventHandlers.closeButtonOnClick);
};
